import React, { useState } from "react";
import { C } from "../theme";
import { fmt, fmtD, Tag, Btn, Inp, Sel } from "../shared";

export const TravauxPage = ({ travaux, setTravaux, immId }) => {
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({description:"",fournisseur:"",devis:"",statut:"Devis"});
  const list = travaux.filter(t => t.immId === immId);
  const save = () => {
    setTravaux(p => [...p, {id:Date.now(), immId, ...form, devis:Number(form.devis), facture:null, date:new Date().toISOString().slice(0,10), avancement:0}]);
    setModal(false);
  };

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
        <div><h2 style={{fontSize:24,fontWeight:800,color:C.text}}>Travaux & Interventions</h2><p style={{color:C.muted,fontSize:13}}>{list.length} projets</p></div>
        <Btn onClick={() => setModal(true)}>+ Nouveau projet</Btn>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16}}>
        {list.map((t, i) => (
          <div key={t.id} className="fu ch" style={{animationDelay:`${i*70}ms`,background:C.card,borderRadius:16,padding:20,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:12}}>
              <Tag s={t.statut} />
              <span style={{fontSize:12,color:C.muted}}>{fmtD(t.date)}</span>
            </div>
            <h4 style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:4}}>{t.description}</h4>
            <p style={{fontSize:12,color:C.muted,marginBottom:12}}>🏗 {t.fournisseur}</p>
            <div style={{marginBottom:5}}>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:C.muted,marginBottom:5}}>
                <span>Avancement</span><span>{t.avancement}%</span>
              </div>
              <div style={{height:6,background:C.border,borderRadius:3,overflow:"hidden"}}>
                <div style={{height:"100%",background:t.avancement===100?C.green:C.teal,width:`${t.avancement}%`,borderRadius:3}} />
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginTop:12}}>
              {[["Devis",t.devis],["Facture",t.facture]].map(([l,v]) => (
                <div key={l} style={{background:C.bg,borderRadius:9,padding:"8px 12px"}}>
                  <p style={{fontSize:10,color:C.muted,fontWeight:700}}>{l}</p>
                  <p style={{fontSize:13,fontWeight:700,color:v?C.text:C.muted}}>{v?fmt(v):"—"}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {modal && (
        <div className="ov" onClick={() => setModal(false)}>
          <div className="mb" onClick={e => e.stopPropagation()}>
            <h3 style={{fontSize:19,fontWeight:800,color:C.text,marginBottom:20}}>Nouveau projet</h3>
            <Inp label="Description" value={form.description} onChange={v => setForm({...form,description:v})} />
            <Inp label="Fournisseur" value={form.fournisseur} onChange={v => setForm({...form,fournisseur:v})} />
            <Inp label="Montant devis (MAD)" type="number" value={form.devis} onChange={v => setForm({...form,devis:v})} />
            <Sel label="Statut" value={form.statut} onChange={v => setForm({...form,statut:v})} options={["Devis","En cours","Terminé","Annulé"]} />
            <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
              <Btn onClick={() => setModal(false)} outline>Annuler</Btn>
              <Btn onClick={save}>Créer</Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

/* ══════════════════════════════════════
   SYNDIC — MARKETPLACE
══════════════════════════════════════ */
